export default __webpack_public_path__ + "img/amex-23b46aa4f55687e366b22f9ba27b2007.png";